// Import du fichier SCSS principal
import '../scss/app.scss';

import Router from './utils/router';
import { initLenis } from './utils/lenis';

initLenis();

new Router([
    {
        module: () => import('./pages/main.js')
    },
    {
        module: () => import('./components/mega-menu.js')
    },
    {
        module: () => import('./components/sticky.js')
    },
    {
        resolve: '.hero-home',
        module: () => import('./sections/hero-home.js')
    },
    {
        resolve: '.hero-anchors',
        module: () => import('./blocks/custom/hero-anchors.js')
    },
    {
        resolve: '.campus-list',
        module: () => import('./blocks/custom/campus-list.js')
    },
    {
        resolve: '.events-list',
        module: () => import('./blocks/custom/events-list.js')
    },
    {
        resolve: '.slider-alumnis',
        module: () => import('./blocks/custom/slider-alumnis.js')
    },
    {
        resolve: '.formation-select--slider',
        module: () => import('./blocks/custom/formation-select.js')
    },
    {
        resolve: '.home-formations',
        module: () => import('./sections/home-formations.js')
    },
    {
        resolve: '[data-iseg-dense], [data-iseg-reseau]',
        module: () => import('./sections/ia-fx.js')
    },
    {
        resolve: '.ia-steps',
        module: () => import('./sections/ia-timeline.js')
    },
    {
        resolve: '.ia-chips',
        module: () => import('./sections/ia-chips.js')
    },
    {
        resolve: '.card-alumni-play',
        module: () => import('./components/card-alumni-video.js')
    },
    {
        resolve: '.verificateur-diplomes',
        module: () => import('./blocks/custom/verificateur-diplomes.js')
    },
    {
        resolve: '.galerie-campus',
        module: () => import('./blocks/custom/galerie-campus.js')
    },
    {
        resolve: '.wp-block-cover__video-background',
        module: () => import('./blocks/core/cover-video.js')
    },
    {
        resolve: '.wp-block-video',
        module: () => import('./blocks/core/video.js')
    },
    {
        resolve: '.wp-block-accordion-panel',
        module: () => import('./blocks/core/accordion.js')
    },
    {
        resolve: '.is-style-lined',
        module: () => import('./components/text-effects.js')
    },
    {
        module: () => import('./utils/animate.js')
    }
]).load();